module.exports = __webpack_public_path__ + "static/media/icon-voc.0cda665f.svg";